import Home from "./pages/Home";
import { Switch, Route } from "react-router-dom"
import ProjectDetails from "./pages/ProjectDetails";
import Nav from "./components/Nav";

function App() {
    return (
        <div className="App">
            <Nav />
            <Switch>
                <Route path='/' exact>
                    <Home />

                </Route>
                <Route path='/projectdetails/:id' exact>
                    <ProjectDetails />
                </Route>
            </Switch>
        </div>
    );
}

export default App;
